export default "__VITE_ASSET__DJEDe8pA__"